// extracted by mini-css-extract-plugin
export var actions = "_3k-0";
export var actionsContainer = "_3k-5";
export var border = "_3k-1";
export var childFullHeight = "_3k-c";
export var collapse = "_3k-2";
export var content = "_3k-7";
export var contentChild = "_3k-b";
export var fullscreen = "_3k-9";
export var headerContainer = "_3k-3";
export var hidePadding = "_3k-8";
export var noScrollX = "_3k-d";
export var noScrollY = "_3k-e";
export var optOutTopPadding = "_3k-a";
export var pagePadding = "_3k-6";
export var profile = "_3k-f";
export var profileContainer = "_3k-g";
export var profileImage = "_3k-h";
export var profileMain = "_3k-i";
export var profileSubtitle = "_3k-k";
export var profileTitle = "_3k-j";
export var tabsWrapper = "_3k-4";
export var title = "_3k-l";